import * as corePixiInit from "./core/initializePixi.js";

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      // console.error(`Error using gameUI.${func}():`, error);
      throw error;
    });

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}

export const cashCashApplicationInit = (pixiStates) => corePixiInit.init(pixiStates)

export const cashCashAssetsLoad = (pixiStates) => corePixiInit.loadPixiAssets(pixiStates)

export const cashCashApplicationDestroy = () => corePixiInit.destroyPixiApp()

export const isSimulate = true
